import createDate from "@shared/factories/src/dateFormat.factory"

const labels = {
  init_date: "Data inicial",
  end_date: "Data final",
  chain: "Rede",
  pos: "PDV",
  seller: "Nome do Vendedor",
  credit: "Crédito",
  base_debt: "Dívida na Base",
  coverage: "Cobertura",
  customer_document: "Documento do Cliente"
}

const names = {
  credit: [
    { text: "Não realizado", value: 1 },
    { text: "Aprovado", value: 2 },
    { text: "Reprovado", value: 3 },
    { text: "Pendente Aprovação", value: 4 }
  ],
  base_debt: [
    { text: "Sim", value: true },
    { text: "Não", value: false }
  ],
  coverage: [
    { text: "Não realizada", value: 1 },
    { text: "Com cobertura", value: 2 },
    { text: "Sem cobertura", value: 3 }
  ]
}

export default {
  init_date: state => {
    return state.filter.init_date
  },

  end_date: state => {
    return state.filter.end_date
  },

  seller: state => {
    return state.filter.seller
  },

  credit: state => {
    return state.filter.credit
  },

  base_debt: state => {
    return state.filter.base_debt
  },

  coverage: state => {
    return state.filter.coverage
  },

  chain: state => {
    return state.filter.chain
  },

  pos: state => {
    return state.filter.pos
  },

  customer_document: state => {
    return state.filter.customer_document
  },

  queryInitDate: state => {
    const dateInitialFormated = createDate(
      state.filter.init_date,
      "DD / MM / YYYY"
    ).format("YYYY-MM-DD")

    return state.filter.init_date ? `from=${dateInitialFormated}` : ""
  },

  queryEndDate: state => {
    const dateFinalFormated = createDate(
      state.filter.end_date,
      "DD / MM / YYYY"
    ).format("YYYY-MM-DD")

    return state.filter.end_date ? `to=${dateFinalFormated}` : ""
  },

  hasFieldAdvancedFilter: (state, { fieldAdvancedFilter }) => {
    return (
      fieldAdvancedFilter.length > 2 ||
      state.filter.init_date != state.standard_dates.init_date ||
      state.filter.end_date != state.standard_dates.end_date ||
      state.filter.credit.length !== 0 ||
      state.filter.base_debt !== "" ||
      state.filter.coverage.length !== 0 ||
      state.filter.chain.length !== 0 ||
      state.filter.pos.length !== 0 ||
      state.filter.customer_document !== ""
    )
  },

  finalQuery: (state, { queryInitDate, queryEndDate }) => {
    const array = [queryInitDate, queryEndDate]

    return array
      .reduce((acc, item) => {
        if (item) return `${acc}&${item}`

        return acc
      }, "")
      .slice(1)
  },

  fieldAdvancedFilter: (
    state,
    {
      init_date,
      end_date,
      seller,
      credit,
      base_debt,
      coverage,
      chain,
      pos,
      customer_document
    }
  ) => {
    const fields = {
      init_date,
      end_date,
      seller,
      credit,
      base_debt,
      coverage,
      chain,
      pos,
      customer_document
    }

    return Object.keys(fields).reduce((acc, key) => {
      if (fields[key]) {
        if (Array.isArray(fields[key])) {
          const arrayFields = fields[key].map(field => ({
            label: labels[key],
            value: field.uuid || field.value,
            name: `${labels[key]}: ${
              names[key]
                ? names[key].find(name => name.value === field.value)?.text
                : field.name || field.text
            }`,
            key
          }))

          return [...acc, ...arrayFields]
        } else {
          return [
            ...acc,
            {
              label: labels[key],
              value: fields[key],
              name: `${labels[key]}: ${
                names[key]
                  ? names[key].find(name => name.value === fields[key].value)
                      ?.text
                  : fields[key]?.name || fields[key]?.text || fields[key]
              }`,
              key
            }
          ]
        }
      }
      return acc
    }, [])
  }
}
